import { useQuery } from "@tanstack/react-query";

import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";

export const useSelectedCareersQueryOptions = () => {
  const queryFn = useApiRequest({
    url: "/users/me/selected-careers",
    method: HttpMethod.Get,
    params: {
      include_lightcast_data: true,
    },
  });

  return {
    queryKey: ["selected-careers"],
    queryFn,
  };
};

export const useSelectedCareers = () => {
  return useQuery(useSelectedCareersQueryOptions());
};
